<template>
  <div class="modal-backdrop" @scroll="scrolled" :class="getClasses" :style="style" @click.stop="closeModal">
    <div class="modal-content2" @scroll="scrolled" :class="modalClass ? modalClass : 'small'" @click.stop="() => {}">
      <div class="wrapper-around-slot" @scroll.stop>
        <span class="close-x-wrapper-2"><close-x v-if="!noX" :close="closeModal"></close-x></span>
        <slot>
          </slot>
      </div>
    </div>
  </div>
</template>

<script>
import CloseX from './close-x';
export default {
  props:['closeModal','modalLevelsOpen','noX','modalClass','zIndex','opaque','full','additionalClass'],
  components:{
    CloseX
  },
  name: "Modal",
  methods:{
    onScroll: function(event) {
    },
    scrolled(event) {
      event.preventDefault();
    }
  },
  beforeCreate() {
    this.$store.commit('ui/setModalOpen',true);
  },
  beforeDestroy() {
    this.$store.commit('ui/setModalOpen',false);
  },
  mounted(){
      if (process.client) {
        document.body.appendChild(this.$el)
      }
    },
  computed:{
    getClasses(){
      var cl = {}
      if(this.opaque) cl['opaque'] = true;
      if(this.additionalClass) cl[this.additionalClass] = true;
      return cl;
    },
    style:function(){
      return {'z-index': this.$props.zIndex ? this.$props.zIndex : 7000 };
    }
  },
  created:function(){
    if(process.browser) document.body.classList.add("modal-open");
  },
  destroyed:function(){
    if(process.browser) document.body.classList.remove("modal-open");
  }
}
</script>

<style lang="scss">
@import '../assets/scss/mixins/no-scrollbar';
@import '../assets/scss/variables/media';
.modal-backdrop {
  position: fixed;
  inset: 0; // covers entire viewport
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.97);
  z-index: 2147483647; // max-safe browser z-index
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 40px;
  padding-top: 10px;
  transform: translateZ(0);
  will-change: transform;
  isolation: isolate;  // <-- critical line
  .close-x-wrapper-new{
    outline:1px red solid;
    position:fixed;
    top:20px;
    right:20px;
  }

  // Lock scroll inside modal only
  overflow-y: auto;
  overscroll-behavior: contain;

  // Force a GPU layer for absolute isolation
  transform: translateZ(0);
  will-change: transform;

  // Fix iOS Safari viewport jumping issues
  @supports (-webkit-touch-callout: none) {
    height: -webkit-fill-available;
  }

  @media (max-width: 768px) {
    padding: 0;
    height: 100svh;
    width: 100svw;
  }

  // Overlay shield to trap rogue high-z-index elements

  /* === Modal content container === */
  .modal-content2 {
    position: relative;
    z-index: 2147483647; // ensure above ::before shield
    background: #fff;
    border-radius: 6px;
    box-shadow:
      rgba(50, 50, 93, 0.5) 0px 13px 27px -5px,
      rgba(0, 0, 0, 0.25) 0px 8px 16px -8px;

    padding: 20px;
    box-sizing: border-box;

    width: 30vw;
    max-height: 90vh;
    overflow-y: auto;

    // Size variants
    &.small { max-width: 400px; }
    &.medium { width: 50vw; }
    &.large { width: 80vw; }
    &.full { width: 99vw; height: 99vh; }

    // Mobile adjustments
    @media (max-width: 768px) {
      width: 95vw;
      max-height: 95vh;
      padding: 15px;
    }
  }

  /* Close button positioning */
}

/* Lock background scroll when modal is open */
body.modal-open {
  overflow: hidden !important;
  height: 100%;
  touch-action: none;
  overscroll-behavior: none;
}



.close-modal-do{
  position:relative;
  .close-x-wrapper-new{
    position: fixed;
    top:20px;
    right:20px;
    z-index: 2147483648;
    outline:5px red solid;
    @media(min-width:$media-mobile){
      display:none;
    }
  }
}

/* Fade-in Transition for Backdrop */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Fade-in Transition for Modal Content */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
  transform: scale(0.9); /* Slight zoom out */
}




</style>
